import { render, staticRenderFns } from "./GAuthSiteFooter.vue?vue&type=template&id=73aab281&scoped=true&"
import script from "./GAuthSiteFooter.vue?vue&type=script&lang=ts&"
export * from "./GAuthSiteFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthSiteFooter.vue?vue&type=style&index=0&id=73aab281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aab281",
  null
  
)

export default component.exports